/**
* Weight Loss Results Slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the Weight Loss Results Slider component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'weight-loss-results-slider',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      if ( $( '.weight-loss-results-slider-slider__slider' ).length ) {
        $( '.weight-loss-results-slider-slider__slider' ).each( function( index, element ) {
          new Splide( element, {
            type: 'loop',
            gap: '2rem',
            perPage: 1,
            perMove: 1,
            pagination: false,
            speed: 800,
          } ).mount( {} );

          $( element ).find( '.weight-loss-results-slider__btn-prev' ).on( 'click', function() {
            $( element ).find( '.splide__arrow--prev' ).trigger( 'click' );
          } );
          $( element ).find( '.weight-loss-results-slider__btn-next' ).on( 'click', function() {
            $( element ).find( '.splide__arrow--next' ).trigger( 'click' );
          } );
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'weight-loss-results-slider', COMPONENT );
} )( app );
